/**
 * FHC Product Card Interactions:
 * - Capture-phase AJAX Add to Cart: opens cart drawer instantly with added product
 * - Zero page refresh
 * - Syncs wishlist state and updates cart count
 */
(function() {
  // Sync Minimog wishlist button states
  function syncWishlist() {
    if (window.MinimogTheme && window.MinimogTheme.Wishlist && typeof window.MinimogTheme.Wishlist.setWishlistButtonsState === 'function') {
      try {
        window.MinimogTheme.Wishlist.setWishlistButtonsState();
      } catch(e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncWishlist);
  } else {
    syncWishlist();
  }

  // Intercept Add to Cart clicks at capture phase
  document.addEventListener('click', async function(e) {
    var btn = e.target.closest('.card-btn-atc');
    if (!btn) return;
    
    var form = btn.closest('form');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled) return;
    var origText = btn.innerText;
    btn.innerText = 'Adding...';
    btn.disabled = true;

    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var variantId = idInput ? idInput.value : null;
    var quantity = qtyInput ? qtyInput.value : 1;

    if (!variantId) {
      btn.innerText = origText;
      btn.disabled = false;
      form.submit();
      return;
    }

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: Number(quantity)
        })
      });

      if (!res.ok) {
        var errBody = await res.json().catch(function() { return {}; });
        throw new Error(errBody.description || 'Add to cart failed with status ' + res.status);
      }

      var item = await res.json();
      btn.innerText = 'Added!';

      // 1. Open Minimog Cart Drawer and refresh content
      if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
        try {
          await window.Shopify.onItemAdded(item, true);
        } catch(err) {
          console.warn('Shopify.onItemAdded error, using direct Cart API:', err);
          if (window.MinimogTheme && window.MinimogTheme.Cart) {
            await window.MinimogTheme.Cart.refreshCart();
            await window.MinimogTheme.Cart.renderNewCart();
            window.MinimogTheme.Cart.openCartDrawer();
          }
        }
      } else if (window.MinimogTheme && window.MinimogTheme.Cart) {
        await window.MinimogTheme.Cart.refreshCart();
        await window.MinimogTheme.Cart.renderNewCart();
        window.MinimogTheme.Cart.openCartDrawer();
      }

      // Fetch fresh cart to ensure theme state is 100% in sync
      var freshCart = null;
      try {
        var cartRes = await fetch('/cart.js');
        freshCart = await cartRes.json();
        if (window.MinimogTheme && window.MinimogTheme.Cart) {
          window.MinimogTheme.Cart.cart = freshCart;
        }
      } catch(e) {}

      // 2. Dispatch theme events with FULL cart object (never single item)
      if (window.MinimogEvents) {
        window.MinimogEvents.emit('cart:updated');
        if (freshCart) {
          window.MinimogEvents.emit('ON_CART_UPDATE', freshCart);
        }
        window.MinimogEvents.emit('cart:item-added', item);
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: item }));

      // 3. Update cart badges
      if (freshCart) {
        var counters = document.querySelectorAll('.sf-cart-count, .cart-count, [data-cart-count]');
        counters.forEach(function(el) { el.textContent = freshCart.item_count; });
      }

      setTimeout(function() {
        btn.innerText = origText;
        btn.disabled = false;
      }, 1500);

    } catch(err) {
      console.warn('ATC fallback to regular submit:', err);
      btn.innerText = origText;
      btn.disabled = false;
      form.submit();
    }
  }, true);

  // Intercept Buy Now clicks on all product cards at capture phase ➔ Razorpay Magic Checkout
  document.addEventListener('click', async function(e) {
    var btn = e.target.closest('.card-btn-buy, .fhc-pcard-btn--buy, [data-buy-now-card]');
    if (!btn) return;

    var form = btn.closest('form');
    var variantId = null;
    var quantity = 1;

    if (form) {
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      if (idInput) variantId = idInput.value;
      if (qtyInput) quantity = qtyInput.value;
    }
    if (!variantId && btn.getAttribute('data-variant-id')) {
      variantId = btn.getAttribute('data-variant-id');
    }
    if (!variantId) {
      var card = btn.closest('article, .fhc-product-card, .tab-product-card, .fhc-card, .sf__col-item');
      if (card) {
        var cardIdInput = card.querySelector('[name="id"]');
        if (cardIdInput) variantId = cardIdInput.value;
      }
    }

    if (!variantId) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled) return;
    var origText = btn.innerText;
    btn.innerText = 'Processing...';
    btn.disabled = true;

    try {
      // 1. Add item to cart
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: Number(quantity)
        })
      });

      if (!res.ok) {
        throw new Error('Failed to add item to cart');
      }

      // 2. Open Razorpay Magic Checkout directly
      if (typeof window.openRzpCheckout === 'function') {
        window.openRzpCheckout(e, { isBuyNow: true });
      } else if (typeof window.onBuyNowClickMagic === 'function') {
        window.onBuyNowClickMagic(e);
      } else {
        window.location.href = '/checkout';
      }
    } catch(err) {
      console.warn('Buy Now error, fallback to form submit:', err);
      if (form) {
        form.submit();
      } else {
        window.location.href = '/checkout';
      }
    } finally {
      setTimeout(function() {
        btn.innerText = origText;
        btn.disabled = false;
      }, 2000);
    }
  }, true);

  // Prevent standard form submission for card-form-buy
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('.card-form-buy');
    if (form) {
      var btn = form.querySelector('.card-btn-buy, button[type="submit"]');
      if (btn) {
        e.preventDefault();
        btn.click();
      }
    }
  }, true);

  // Fallback handler for cart drawer remove buttons in case of any state mismatch
  document.addEventListener('click', async function(e) {
    var removeBtn = e.target.closest('.scd-item__remove');
    if (!removeBtn) return;

    var key = removeBtn.dataset.id;
    if (!key) return;

    if (window.MinimogTheme && window.MinimogTheme.Cart) {
      var cart = window.MinimogTheme.Cart.cart;
      var hasItem = cart && Array.isArray(cart.items) && cart.items.some(function(it) { return it.key === key; });
      
      // If MinimogTheme.Cart.cart does not have this item registered, perform direct removal
      if (!hasItem) {
        e.preventDefault();
        e.stopPropagation();
        try {
          if (typeof window.MinimogTheme.Cart.changeItemQty === 'function') {
            await window.MinimogTheme.Cart.changeItemQty({ id: key, quantity: 0 });
          } else {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            });
            await window.MinimogTheme.Cart.refreshCart();
            await window.MinimogTheme.Cart.renderNewCart();
          }
        } catch(err) {
          console.error('Direct removal fallback failed:', err);
        }
      }
    }
  });

  // Prevent standard form submission if triggered via Enter key
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('.card-form-atc');
    if (form) {
      e.preventDefault();
      var btn = form.querySelector('.card-btn-atc');
      if (btn) btn.click();
    }
  }, true);
})();
